module.exports = __webpack_public_path__ + "static/band-wide-0283d69743c0572c53ad175bd7b93dbe.png";